var homeController = (function () {
    function homeController($window) {
        this.$window = $window;
    }
    homeController.prototype.logIn = function () {
        this.$window.location.href = "/loginw3";
    };
    homeController.$inject = ['$window'];
    return homeController;
}());
var homeComponent = (function () {
    function homeComponent() {
        this.templateUrl = 'home.html';
        this.controllerAs = 'vm';
        this.controller = homeController;
    }
    return homeComponent;
}());
angular
    .module('application')
    .component('homeSection', new homeComponent());

//# sourceMappingURL=home.component.js.map
